import { useMemo } from "react";
import { Select } from "../controls";
import { useCategories, sortOthersLast } from "../hooks/queries";

const CategoryDropdown = ({ name, value, onChange }: any) => {
  const { data = [] } = useCategories();

  // "Other"/"Others" sinks to the end; the rest keep their original order.
  const cats = useMemo(
    () => sortOthersLast(data).map((k: any) => ({ label: k?.name, value: k?._id })),
    [data]
  );

  return (
    <Select
      name={name}
      title="Choose..."
      options={cats}
      showFirstOption={true}
      value={value}
      onChange={onChange}
    />
  );
};

export default CategoryDropdown;
